import { usePath } from "@/contexts/path/path";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { useFindListingsFrozenFilter } from "@/components/new-resolver/useFindListings";
import React, { useEffect, useState } from "react";
import css from "@/components/Listing/ListingScreen/.module.scss";
import logger from "@/console";
import FavButton from "@/components/Listing/ListingScreen/ListingControls/favButton";
import ShareButton from "@/components/Listing/ListingScreen/ListingControls/shareButton";
import ReportButton from "@/components/Listing/ListingScreen/ListingControls/reportButton";
import Icon from "@/components/icon";
import { trackGenericCTAClickEvent } from "@/lib/tracking/trackNavigationEvents";

export function GeneralControls({ listing }) {
  const { user } = useAuthState();

  return (
    <div className={css.generalControls}>
      <FavButton listing={listing} />
      <ShareButton type="listing" listing={listing} />
      {listing.user_id !== user?.user_id ? (
        <ReportButton listingID={listing?.id} />
      ) : null}
    </div>
  );
}
export function PreviousListingButton({
  frozenContext,
  onListingChange,
  children,
}) {
  const {
    currentFrozenIndex: idx,
    daily_renting_filter,
    resolving,
    category,
  } = usePath();
  const [currentFrozenIndex, setCurrentFrozenIndex] = useState(idx || 0);
  const [frozenListings, { total, fetchMore, loading }] =
    useFindListingsFrozenFilter(frozenContext);

  const [disableNextAndPrevious, setDisableNextAndPrevious] = useState(false);
  useEffect(() => {
    if (resolving) return setDisableNextAndPrevious(true);
    const id = setTimeout(() => setDisableNextAndPrevious(false), 100);
    return () => {
      clearTimeout(id);
    };
  }, [resolving]);

  useEffect(() => {
    function ls(e) {
      setCurrentFrozenIndex(e.detail?.index || 0);
    }
    document.addEventListener("updatefrozenindex", ls);

    return () => document.removeEventListener("updatefrozenindex", ls);
  }, []);
  return (
    <button
      disabled={
        disableNextAndPrevious ||
        loading ||
        resolving ||
        !frozenListings?.length ||
        !currentFrozenIndex
      }
      data-event-target="previous listing"
      onClick={(e) => {
        trackGenericCTAClickEvent(e, {
          listing_type: category?.ga_listing_type,
          property_category: category?.ga_property_category,
        });
        let acc = currentFrozenIndex - 1;

        if (!frozenListings[acc]) return;

        if (acc % 20 === 19) {
          fetchMore(frozenListings.length);
        }

        setCurrentFrozenIndex(acc);
        const listing_ = frozenListings[acc];

        onListingChange({
          listing: frozenListings[acc],
          currentFrozenIndex: acc,
          dailyData: daily_renting_filter?.day_date
            ? {
                price: {
                  total_price: listing_.original_range_price || 0,
                  discounted_price: listing_.range_price || 0,
                  discount_reason: listing_.daily_renting_discount_reason,
                },
              }
            : undefined,
        });
      }}
      type="button"
    >
      <Icon
        className="mirror"
        width={15}
        height={15}
        name="leftArrow-searches"
      />
      {children}
    </button>
  );
}
export function NextListingButton({
  frozenContext,
  onListingChange,
  children,
}) {
  const {
    currentFrozenIndex: idx,
    daily_renting_filter,
    resolving,
    category,
  } = usePath();
  const [currentFrozenIndex, setCurrentFrozenIndex] = useState(idx || 0);
  const [frozenListings, { total, fetchMore, loading }] =
    useFindListingsFrozenFilter(frozenContext);
  const [disableNextAndPrevious, setDisableNextAndPrevious] = useState(false);
  useEffect(() => {
    if (resolving) return setDisableNextAndPrevious(true);
    const id = setTimeout(() => setDisableNextAndPrevious(false), 100);
    return () => {
      clearTimeout(id);
    };
  }, [resolving]);

  useEffect(() => {
    function ls(e) {
      setCurrentFrozenIndex(e.detail?.index || 0);
    }

    document.addEventListener("updatefrozenindex", ls);

    return () => document.removeEventListener("updatefrozenindex", ls);
  }, []);
  return (
    <button
      disabled={
        disableNextAndPrevious ||
        loading ||
        resolving ||
        !frozenListings.length ||
        currentFrozenIndex + 1 >= total
      }
      data-event-target="next listing"
      onClick={(e) => {
        trackGenericCTAClickEvent(e, {
          listing_type: category?.ga_listing_type,
          property_category: category?.ga_property_category,
        });

        let acc = 1 + currentFrozenIndex;
        while (frozenListings[acc]?.native) {
          logger.log("native", { acc });
          acc++;
        }
        if (!frozenListings[acc]) return;

        if (acc % 20 === 19) {
          fetchMore(frozenListings.length);
        }
        const listing_ = frozenListings[acc];
        setCurrentFrozenIndex(acc);
        onListingChange({
          listing: listing_,
          currentFrozenIndex: acc,
          dailyData: daily_renting_filter?.day_date
            ? {
                price: {
                  total_price: listing_.original_range_price || 0,
                  discounted_price: listing_.range_price || 0,
                  discount_reason: listing_.daily_renting_discount_reason,
                },
              }
            : undefined,
        });
      }}
      type="button"
    >
      {children}
      <Icon width={15} height={15} name="leftArrow-searches" />
    </button>
  );
}

export function PreviousListingButtonDaily({
  onListingChange,
  children,
  frozenListings,
  propertyCategory,
  listingType,
}) {
  const {
    currentFrozenIndex: idx,
    daily_renting_filter,
    resolving,
    category,
  } = usePath();
  const [currentFrozenIndex, setCurrentFrozenIndex] = useState(idx || 0);

  const [disableNextAndPrevious, setDisableNextAndPrevious] = useState(false);
  useEffect(() => {
    if (resolving) return setDisableNextAndPrevious(true);
    const id = setTimeout(() => setDisableNextAndPrevious(false), 100);
    return () => {
      clearTimeout(id);
    };
  }, [resolving]);

  useEffect(() => {
    function ls(e) {
      setCurrentFrozenIndex(e.detail?.index || 0);
    }
    document.addEventListener("updatefrozenindex", ls);

    return () => document.removeEventListener("updatefrozenindex", ls);
  }, []);
  return (
    <button
      disabled={
        disableNextAndPrevious ||
        resolving ||
        !frozenListings?.length ||
        !currentFrozenIndex
      }
      data-event-target="previous listing"
      onClick={(e) => {
        trackGenericCTAClickEvent(e, {
          listing_type: category?.ga_listing_type || listingType,
          property_category: category?.ga_property_category || propertyCategory,
        });
        let acc = currentFrozenIndex - 1;

        if (!frozenListings[acc]) return;

        setCurrentFrozenIndex(acc);
        const listing_ = frozenListings[acc];

        onListingChange({
          listing: frozenListings[acc],
          currentFrozenIndex: acc,
          dailyData: daily_renting_filter?.day_date
            ? {
                price: {
                  total_price: listing_.original_range_price || 0,
                  discounted_price: listing_.range_price || 0,
                  discount_reason: listing_.daily_renting_discount_reason,
                },
              }
            : undefined,
        });
      }}
      type="button"
    >
      <Icon
        className="mirror"
        width={15}
        height={15}
        name="leftArrow-searches"
      />
      {children}
    </button>
  );
}
export function NextListingButtonDaily({
  onListingChange,
  children,
  frozenListings,
  propertyCategory,
  listingType,
}) {
  const {
    currentFrozenIndex: idx,
    daily_renting_filter,
    resolving,
    category,
  } = usePath();
  const [currentFrozenIndex, setCurrentFrozenIndex] = useState(idx || 0);

  const total = frozenListings?.length || 0;
  const [disableNextAndPrevious, setDisableNextAndPrevious] = useState(false);
  useEffect(() => {
    if (resolving) return setDisableNextAndPrevious(true);
    const id = setTimeout(() => setDisableNextAndPrevious(false), 100);
    return () => {
      clearTimeout(id);
    };
  }, [resolving]);

  useEffect(() => {
    function ls(e) {
      setCurrentFrozenIndex(e.detail?.index || 0);
    }

    document.addEventListener("updatefrozenindex", ls);

    return () => document.removeEventListener("updatefrozenindex", ls);
  }, []);
  return (
    <button
      disabled={
        disableNextAndPrevious ||
        resolving ||
        !frozenListings.length ||
        currentFrozenIndex + 1 >= total
      }
      data-event-target="next listing"
      onClick={(e) => {
        trackGenericCTAClickEvent(e, {
          listing_type: category?.ga_listing_type || listingType,
          property_category: category?.ga_property_category || propertyCategory,
        });

        let acc = 1 + currentFrozenIndex;
        while (frozenListings[acc]?.native) {
          logger.log("native", { acc });
          acc++;
        }
        if (!frozenListings[acc]) return;

        const listing_ = frozenListings[acc];
        setCurrentFrozenIndex(acc);
        onListingChange({
          listing: listing_,
          currentFrozenIndex: acc,
          dailyData: daily_renting_filter?.day_date
            ? {
                price: {
                  total_price: listing_.original_range_price || 0,
                  discounted_price: listing_.range_price || 0,
                  discount_reason: listing_.daily_renting_discount_reason,
                },
              }
            : undefined,
        });
      }}
      type="button"
    >
      {children}
      <Icon width={15} height={15} name="leftArrow-searches" />
    </button>
  );
}
